var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"tw-p-4 tw-font-semibold tw-text-gray-500 first:tw-pl-0 last:tw-pr-0 last:tw-text-right"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }